

$(document).ready(function(){
    $(".cstm-lang-country").click(function(event){
        event.stopPropagation();
        $(".cstm-lang-country-colored").show();
        $(".show_country_lang").fadeIn(100);
        $(".cstm-lang-country").hide();
        
    });

    $(".cstm-lang-country-colored").click(function(event){
        event.stopPropagation();
        $(".cstm-lang-country").show();
        $(".show_country_lang").fadeOut(100);
        $(".cstm-lang-country-colored").hide();
    });

    $("body").click(function(){
        $(".cstm-lang-country-colored").trigger("click");
    });

    $(".cstm-lang-country, .cstm-lang-country-colored").click(function(event){
        event.stopPropagation();
    });

});

$(document).ready(function () {
  var countryList = [];
  $('.countries button').each(function() {
    countryList.push($(this).val());
  });
  console.log(countryList)
  var currency = $('.cstm-country-li').find('span').text().trim();
  var country_name = currency.split('|')[0];

  var language = $('.cstm-language-li').find('span').text().trim();
 
  var regex = new RegExp(countryList.join("|"), "i");
  
  var country_currency = currency.match(regex);
  
  if (country_currency && country_currency.length > 0 && language && language.length > 0) {
   
  }
   var uniqueLanguage = language.split(' ')[0];
    if (language.indexOf(uniqueLanguage) !== -1) {
      language = language.replace(uniqueLanguage).trim(); 
    }
 var getLanguage = [];
$('.language:first .disclosure__list .disclosure__item').each(function() {
  if (!$(this).find('.visibility-hidden').length) {
    getLanguage.push($(this).find('span').last().text().trim());
  }
});
var languagenew = getLanguage.join(', ');  
    $(".country-language-display").text(country_name + " - " + languagenew);
});


$(document).ready(function(){
//$('.deferred-media').parents('.slick-slide').hide();

// $('span.deferred-media__poster-button').click(function() {
//    $(this).parents('.product-media-container').find('.cstm-popup').show();
// });
  //   $('.product-media-container.media-type-external_video').click(function() {
//    $(this).find('.cstm-popup').show();
// });
$("body").on("click",".show-more-btn",function(){
  $(this).parents(".cstm-less-desc").attr("style","display: none");
  $(".custom_short_des.full-desc").attr("style","display: block");
});
$("body").on("click",".show-less-btn",function(){
  $(this).parents(".full-desc").attr("style","display: none");
  $(".cstm-less-desc").attr("style","display: block");
}); 
  if($('.cart__ctas ul').find('li').text().trim() === ''){
   
    $('.cart__ctas ul').find('li').remove();
}

  
 if($(window).width() > 749){

      $(document).on('click','span.video-close-icon',function(){
      $('.product-media-container.media-type-external_video').find('.cstm-popup.cstm-desktop-popup').hide();
      })

      
       $(document).on('click','.product-media-container.media-type-external_video',function(){
           $(this).find('.cstm-popup.cstm-desktop-popup').show();
         $('.cstm-popup.cstm-desktop-popup').removeClass('new-cstm-popup');
         });
 }
  
  $('.product-media-modal__toggle').click(function () {
     $('.product-media-modal').removeAttr('open');
    $('body').removeClass('overflow-hidden');   
})

   $('.cstm-product__description').hide();
    $('.cstm-specification-table').hide();
     $('.cstm-product--description').click(function() {
          $('.cstm-product--specification').removeClass('change-icon');
         $('.cstm-specification-table').hide();
      $('.cstm-product__description').slideToggle(); 
        $(this).toggleClass('change-icon');
       });

   
    $('.cstm-product--specification').click(function() {
     $('.cstm-product--description').removeClass('change-icon');
   $('.cstm-product__description').hide();
      $('.cstm-specification-table').slideToggle(); 
 $(this).toggleClass('change-icon');     
    });
 if($(window).width() < 749){
var intervalId = setInterval(function() {
$('.cstm-mobilecontainer---jtpl').find('.product-grid').addClass('mobile-slider-main-product1');
    if ($('.mobile-slider-main-product1').length) {
       
        $('.mobile-slider-main-product1').slick({
            infinite: false,
            slidesToShow: 1.10,
            slidesToScroll: 1,
           
            swipeToSlide: true,
            arrows: false,
            dots: false
        });
        clearInterval(intervalId);  
      $('.mobile-slider-main-product1 .slick-active').prevAll('.slick-cloned').css('margin-left', '20px');
  $('.mobile-slider-main-product1').on('init reInit afterChange', function(event, slick, currentSlide){
    $('.mobile-slider-main-product1 .slick-cloned').css('margin-left', '0'); 
    $('.mobile-slider-main-product1 .slick-active').prevAll('.mobile-slider-main-product1 .slick-cloned').css('margin-left', '20px');
  });  
    }

}, 100);  

 $(document).on('click','.slick-slide .product__modal-opener--external_video',function(){

    $('.product-media-modal').removeAttr('open');
    $('body').removeClass('overflow-hidden');
    $('.mb-custom-popup').show();
});
    $(document).on('click','.mb-custom-popup .video-close-icon',function(){

    
     $('.mb-custom-popup').hide();
})

 }
  var height = $('.product__media-item').height();
$('.product__media-item--full').find('.deferred-media').height(height);

 if($(window).width() > 749){
    $(document).on('click','.video-popup-close-icon',function(){
    //$('.cstm-popup').addClass('new-cstm-popup');
       $('.cstm-popup.cstm-desktop-popup').hide();
        setTimeout (function () {
           //$('.cstm-popup').addClass('new-cstm-popup');
           $('.cstm-popup.cstm-desktop-popup').hide();
        },50);
   
   
   
})
 }

 if($(window).width() < 749){
  $('.cstm-pro-slick-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
           
            swipeToSlide: true,
            arrows: false,
            dots: true
        });

   
 }







//cart total price update

// function totalPriceUpdate() {
   
//     var input1 = $('.totals__total-value:first').text();
//     var currencyPart = input1.replace(/[\d,\.]/g, '').trim();
//     var total = 0;

    
//     $('.price--end').each(function (i) {
//         if (i % 2 === 0) { 
//             var amount = $(this).text().trim();
//             var numberPart = amount.split(' ')[0].replace(/,/g, '');
//             var number = parseFloat(numberPart);
//             total += number;
//         }
//     });

   
//     var formattedTotal = total.toLocaleString();
//     var totalValue = formattedTotal +' '+ currencyPart;
//     console.log(totalValue);
//     $('.totals__total-value').text(totalValue);
// }


// $(document).on('click', '.quantity__button', function() {
    
//     setTimeout(function() {
//         totalPriceUpdate();
//     }, 2000); 
// });

// $(document).on('keyup keydown', '.quantity__input', function(event) {
    
//     if (event.type === 'keyup' || (event.type === 'keydown' && event.key === 'Enter')) {
//         setTimeout(function() {
//             totalPriceUpdate();
//         }, 2000); 
//     }
// });

//   $(document).on('click', 'cart-remove-button', function() {
//       setTimeout(function() {
//         totalPriceUpdate();
//     }, 2000); 
//     });




   $(document).on('click', '.facets__summary', function(event) {
     $('.desktop-sort-list').hide();
      $('.facets__summary ').attr('aria-expanded','false');
$(this).attr('aria-expanded','true')
    event.stopPropagation(); 
     var $popup = $(event.currentTarget).parents('.disclosure-has-popup');
     if ($popup.attr('open')) {
       $popup.removeAttr('open');
       $('.cstm-facet-filters__field').find('.custom-accordian-is-active').removeClass('custom-accordian-is-active');
     setTimeout(function() {
         $popup.removeAttr('open');
        }, 200);
    } else {
        $('.disclosure-has-popup').removeAttr('open');
        $('.cstm-facet-filters__field').find('.custom-accordian-is-active').removeClass('custom-accordian-is-active');
         setTimeout(function() {
         $popup.attr('open', 'true');
        }, 500);
    }
  
});


 $(document).on('click', function(event) {
    
    if (!$(event.target).closest('.disclosure-has-popup').length) {
        $('.disclosure-has-popup').removeAttr('open');
        $('.cstm-facet-filters__field').find('.custom-accordian-is-active').removeClass('custom-accordian-is-active');
    $('.facets__summary ').attr('aria-expanded','false');
    }
   if (!$(event.target).closest('.cstm-facet-filters__field').length) {
        $('.cstm-facet-filters__field').find('.custom-accordian-is-active').removeClass('custom-accordian-is-active');
    }
});



function updateButtonVisibility() {
    if ($('.active-facets__button--light').length > 2) {
       $('.active-facets__button-remove').removeClass('custom-remove-filter-btn');
        $('.active-facets__button-remove').show();
      
    } else {
        $('.active-facets__button-remove').hide();
       $('.active-facets__button-remove').addClass('custom-remove-filter-btn')
    }
}
  

updateButtonVisibility();
setInterval(updateButtonVisibility, 10);



   
 
   
   
       $(document).on('click', '.cstm-sortby-btn', function(event) {
      $('.disclosure-has-popup').removeAttr('open');
       $('.facets__summary ').attr('aria-expanded','false');
       $('.cstm-facet-filters__field').find('.custom-accordian-is-active').removeClass('custom-accordian-is-active');
        event.stopPropagation(); 
        setTimeout(function() {
            var $sortList = $('.desktop-sort-list');
            if ($sortList.is(':visible')) {
                $sortList.hide();
            } else {
                $sortList.show();
            }
        }, 200);
    });

    
    $(document).click(function () {
        $('.desktop-sort-list').hide();
    });



//  $(document).on('click', '.slick-slide', function(event) {
  
//     $('.cstm-popup').hide();
    
// })

  
//  $(document).on('click', '.icon-close', function(event) {
//       $('.cstm-popup').hide();
    
// })
  setInterval(function() {
    if ($('.cart-item').length > 1) {
        $('.custom-cart-page-content').show();
    } else {
        $('.custom-cart-page-content').hide();
    }
}, 100); // 1000 milliseconds = 1 second


$(".custom-anouncement-bar").mouseover(function(){
    $('.custom-close').show();
});
$(".utility-bar").mouseleave(function(){
    $('.custom-close').hide();
});
$('.custom-close').click(function(){
    $(".custom-anouncement-bar").slideUp();
});  


// $('.check').click(function () {
//     if ($(this).is(':checked')) {
//        $('.cart__ctas .cart__checkout-button').removeClass('custom-diable');
//     } else {
//          $('.cart__ctas .cart__checkout-button').addClass('custom-diable');
//     }
// });

 $('.cart-btn').click(function() {
    if($(this).is(':checked'))
     $('.cart__ctas .cart__checkout-button').removeClass('custom-disable');
    else
        $('.cart__ctas .cart__checkout-button').addClass('custom-disable');
}); 


  $.ajax({
    url: "https://ipinfo.io/json",
    type: 'GET',
    success: function(res) {
      if(res.country == 'DE' || res.country == 'de'){
        $('.germany').show();
       } 
      else if(res.country == 'FR' || res.country == 'fr'){
      $('.france').show();
      }else if(res.country == 'AT' || res.country == 'at'){
      $('.austria').show();
      }else{
        $('.country-payement-icon').show();
      }
      
         }
  });
if($("variant-selects .product-form__input").length > 0){
  $('.product-form__submit').attr('disabled','disabled');
}
$(document).on('click', '.cstmbtncheck', function() {
    var getData = $(this).attr('variant-id');  
    setTimeout(() => {
        $('.show-' + getData).prop('checked', true);  
    }, 1300);
});

  
});